import { Sector } from '../../app/types';

export type Organization = {
  alertFeedEmail: string;
  alertPhone: string;
  guid?: string;
  maxUsers: number;
  name: string;
  optIn: boolean;
  organizationId: string;
  sectors: Sector[];
  status: OrganizationStatus;
  tlsEmail: string;
  userCount: number;
  enterpriseNumber?: string;
};

export type OrganizationFilters = {
  search?: string;
  sector?: OrganizationSector[];
  status?: OrganizationStatus[];
};

export enum OrganizationStatus {
  Activated = 'activated',
  Imported = 'imported',
  New = 'new',
  Pending = 'pending',
  ReEvaluation = 'reEvaluate',
  Rejected = 'rejected',
  Suspended = 'suspended',
  ToCorrect = 'toCorrect',
  Waiting = 'waiting',
}

export enum OrganizationType {
  Basic = 'basic',
  Important = 'important',
  Essential = 'essential'
}

export type OrganizationSector = {
  name: string;
  sectorId: string;
  parent?: OrganizationSector;
};

export type AddOrganizationFormValues = {
  emailAdminUser: string;
  enterpriseNumber?: string;
  maxUsers: number;
  name: string;
  sectors: OrganizationSector[];
  type?: OrganizationType;
  receiveAlerts: boolean;
};

export type AddOrganizationValues = {
  emailAdminUser: string;
  maxUsers: number;
  name: string;
  sectors: string[];
  type?: OrganizationType;
  receiveAlerts: boolean;
};

export type EditOrganizationValues = {
  maxUsers: number;
  enterpriseNumber?: string;
  name: string;
  sectors: OrganizationSector[];
  type?: OrganizationType;
  receiveAlerts: boolean;
};

export enum UpdateStep {
  needsUpdate = 'needsUpdate',
  generalInfoCompleted = 'generalInfoCompleted',
  contactsCompleted = 'contactsCompleted',
  allUpToDate = 'allUpToDate',
}

export type OrganizationUpdateStep = {
  lastUpdate: Date;
  organizationId: string;
  updateStep: UpdateStep;
};
